<main class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1>Cadastro de Pesquisas</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-6" style="padding-right: 3rem;">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col texto-perguntas">
                        Sobre o que é a pesquisa?
                        <input formControlName="vc_descricao" type="text" class="input-perguntas">
                    </div>
                </div>
                <div class="row">
                    <div class="col texto-perguntas espacamento">
                        Título:
                        <input formControlName="vc_titulo" type="text" class="input-perguntas">
                    </div>
                </div>
                <div class="row">
                    <div class="col texto-perguntas espacamento">
                        Subtitulo:
                        <input formControlName="vc_subtitulo" type="text" class="input-perguntas">
                    </div>
                </div>
                <div class="row">
                    <div class="col texto-perguntas espacamento">
                        Produto:
                        <select formControlName="fk_produto" class="input-perguntas texto-perguntas" >
                            <option *ngFor="let produto of produtos" [value]="produto.sr_id">
                                {{produto.vc_nome}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col texto-perguntas espacamento">
                        Deseja que a pesquisa apareça depois de quanto tempo?
                        <input formControlName="it_verificacao" type="number" class="input-perguntas" min="1">
                    </div>
                </div>
                <div class="row">
                    <div class="col texto-perguntas espacamento d-flex justify-content-between">
                        Deseja inserir o campo de “Observação”?
                        <label>
                            <input type="radio" value="Sim" formControlName="vc_observacao">
                            <span class="align-bottom" style="margin:0; margin-left: .3rem;">Sim</span>
                        </label>
                        <label>
                            <input type="radio" value="Nao" formControlName="vc_observacao">
                            <span class="align-bottom" style="margin:0; margin-left: .3rem;">Não</span>
                        </label>
                    </div>
                </div>
                <div class="row" *ngIf="form.value.vc_observacao == 'Sim'">
                    <div class="col texto-perguntas espacamento d-flex justify-content-between">
                        Pergunta da "Observação": 
                        <input formControlName="vc_frase_observacao" type="text" class="input-perguntas sem-margem texto-perguntas" placeholder="Observação">
                    </div>
                </div>
                <div class="row texto-perguntas d-flex justify-content-center">
                    Perguntas
                </div>
                <div class="row">
                    <div formArrayName="ar_perguntas">
                        <div *ngFor="let input of inputs; let i = index">
                            <div [formGroupName]="i" class="d-flex flex-row mt-3">
                                <input formControlName="vc_pergunta" type="text" class="input-perguntas sem-margem texto-perguntas" placeholder="Pergunta">
                                <button class="botao-grupo-respostas texto-perguntas" (click)="selecionarGrupo(i)" *ngIf="form.get('ar_perguntas')!.value[i].fk_grupo_resposta==''">
                                    <img src="../../../assets/adiconar.svg"> 
                                    Grupo de respostas
                                </button>
                                <button class="botao-grupo-respostas texto-perguntas" (click)="selecionarGrupo(i)" *ngIf="form.get('ar_perguntas')!.value[i].fk_grupo_resposta!=''">
                                    {{form.get('ar_perguntas')!.value[i].fk_grupo_resposta.vc_nome}}
                                    <img src="../../../assets/editar_pesquisa.svg"> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row texto-perguntas d-flex justify-content-center">
                    <img src="../../../assets/adiconar.svg" class="adiconar" (click)="adicionarPergunta()">
                </div>
            </form>
        </div>
        <div class="col-6 exemplo-dialog">
            <div class="d-flex flex-column justify-content-center text-center mb-3">
                <span class="titulo" *ngIf="form.value.vc_titulo==''">Título</span>
                <span class="titulo">{{form.value.vc_titulo}}</span>
                <span class="textos" *ngIf="form.value.vc_subtitulo==''">Subtítulo</span>
                <span class="textos">{{form.value.vc_subtitulo}}</span>
            </div>
            <div *ngFor="let pergunta of form.value.ar_perguntas">
                <span class="textos espacamento">{{pergunta.vc_pergunta}}</span>
                <div class="d-flex flex-row justify-content-center">
                    <div *ngFor="let nota of pergunta.fk_grupo_resposta.notas" class="m-2">
                        <img [src]="nota.vc_icone"/>
                    </div>
                </div>
            </div>
            
            <span *ngIf="form.value.vc_observacao=='Sim'" class="textos espacamento">{{form.value.vc_frase_observacao}}: </span>
            <textarea *ngIf="form.value.vc_observacao=='Sim'" rows="6" cols="40"  class="area-de-texto espacamento-menor"></textarea>
            <div class="d-flex flex-row-reverse">
                <button class="botao-criar">Enviar</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <button (click)="cadastrar()" class="botao-criar">Criar</button>
        </div>
    </div>
</main>